<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">场馆预约审核</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1"></OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择组织结构" @focus="dialogOpen1" style="width:320px;" @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="场馆">
          <el-select v-model="formInline.training_no" filterable clearable placeholder="请选择场馆">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.status" clearable placeholder="请选择状态">
            <el-option label="待审核" value="apply"></el-option>
            <el-option label="已通过" value="pass"></el-option>
            <el-option label="已拒绝" value="refuse"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="日期">
          <el-date-picker v-model="formInline.date" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">预约场馆</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleExport">{{exportTitle}}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" ref="table" border style="width: 100%">
        <custom-table-column fixed prop="training_name" label="场馆名称" width="160">
        </custom-table-column>
        <custom-table-column prop="status" label="状态" width="160" :formatter="format_status_str">
        </custom-table-column>
        <custom-table-column prop="creator_name" label="预约人名称" width="120">
        </custom-table-column>
        <custom-table-column prop="order_user_dep" label="预约人院系" width="160">
        </custom-table-column>
        <custom-table-column prop="major" label="专业" width="180">
        </custom-table-column>
        <custom-table-column prop="phone" label="联系方式" width="135">
        </custom-table-column>
        <!-- <custom-table-column prop="phone" label="预约电话" width="135">
        </custom-table-column> -->
        <custom-table-column prop="instrument_name" label="设备名称" min-width="220" show-overflow-tooltip>
        </custom-table-column>
        <custom-table-column prop="order_start" label="开始时间" width="160">
          <template slot-scope="scope">
            <span>{{scope.row.order_start? $until.getTimeStr(new Date(scope.row.order_start).getTime() / 1000,'-'):''}}</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="order_end" label="结束时间" width="160">
          <template slot-scope="scope">
            <span>{{scope.row.order_end? $until.getTimeStr(new Date(scope.row.order_end).getTime() / 1000,'-'):''}}</span>
          </template>
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row,farr)" v-if="scope.row.status=='apply'" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false"  :title="title" :visible.sync="centerDialogVisible" width="770px">
      <OrganDialog ref="organDia" @getSelect="getSelect" :level="levell" @handleOrganQuery="handleOrganQuery"></OrganDialog>

      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="132px" class="demo-ruleForm">
        <el-form-item label="预约人院系专业" prop="major">
          <el-input v-model="selectName" placeholder="请选择预约人院系专业" style="width:564px;" @focus="dialogOpen" @clear="handeleClear" clearable></el-input>
          <!-- <el-select v-model="selectName" style="width:564px;" clearable filterable placeholder="请选择院系+专业" @change="handleOrganChange">
            <el-option v-for="item in $store.state.userInfo.structureList" :key="item.id" :label="item.structure_text2" :value="item.structure_text2"></el-option>
          </el-select> -->
        </el-form-item>
        <!-- <el-form-item label="专  业" prop="major">
          <el-input v-model="ruleForm.major" placeholder="请输入专业" style="width:216px;"></el-input>
        </el-form-item> -->
        <el-form-item label="场馆" prop="training_no">
          <el-select v-model="ruleForm.training_no" filterable style="width:216px;"  placeholder="请选择场馆" @change="handleClassChange">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.training_no"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系方式" prop="phone">
          <el-input v-model="ruleForm.phone" placeholder="请输入联系方式" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="课程名称" prop="course_name">
          <el-input v-model="ruleForm.course_name" placeholder="请输入课程名称" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="设备名称" prop="instrument_name">
          <el-input v-model="ruleForm.instrument_name" placeholder="请输入设备名称" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="开始时间" prop="order_start">
          <el-date-picker type="datetime" placeholder="选择开始时间" value-format="yyyy-MM-dd HH:mm:ss"  v-model="ruleForm.order_start" style="width:216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="order_end">
          <el-date-picker type="datetime" placeholder="选择结束时间" value-format="yyyy-MM-dd HH:mm:ss" v-model="ruleForm.order_end" style="width:216px;"></el-date-picker>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type=='add'" @click="submitForm('ruleForm')">确认</el-button>
          <el-button type="primary" v-if="type=='edit'" @click="submitForm('ruleForm')">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false"  title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinFormatter } from '@/assets/js/mixin/formatter';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan, mixinValidate,mixinFormatter],
  data() {
    return {
      classRooms: [],

      farr: ['order_user_id', 'school_id', 'created_at', 'updated_at', 'deleted_at', 'order_date', 'class_plan_id', 'order_user_name'],
      formInline: {
        training_no: '',
        status: '',
        structure_1: '',
        major: '',
      },
      levell: [1, 2],
      selectName: '',
      organLabel: '',
      ruleForm: {
        order_user_dep: '',
        order_start: '',
        order_end: '',
        phone: '',
        training_name: '',
        training_no: '',
        major: '',
        instrument_name: '',
        course_name: '',
      },
      rules: {
        major: [{ required: true, message: '请选择院系+专业' }],
        // order_user_dep: [{ required: true, message: '请选择预约人所在院系', trigger: '' }],
        instrument_name: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        course_name: [{ required: true, message: '请输入课程名称', trigger: 'blur' }],
        training_no: [{ required: true, message: '请选择场馆', trigger: 'change' }],

        phone: [
          { required: true, message: '联系方式不能为空', trigger: 'blur' },
          { validator: this.checkphone, trigger: 'blur' },
        ],
        order_start: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
        order_end: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
      },
      type: 'add',
      tableName: '实训日志',
      userInfo: {},
    };
  },
  created() {
    // this.userInfo = this.$store.state.userInfo;
  },
  mounted() {
    // this.getList();
    this.title = '预约场馆';
    this.$store.dispatch('getTarinMent', { type: 'all' });
  },
  // watch: {
  //   '$store.state.userInfo.defaultStructure': {
  //     handler: function (val) {
  //       this.userInfo = this.$store.state.userInfo;
  //       if (val) {
  //         this.selectName = val.structure_text2;
  //       }
  //     },
  //     deep: false,
  //   },
  // },
  methods: {
    handleAdd() {
      this.type = 'add';
      this.title = '新增';
      this.ruleForm = this.$until.easyDeepCopy(this.ruleFormTep);
      if(this.userInfo.defaultStructure){
      this.selectName=  this.userInfo.defaultStructure.structure_text2
      }
      this.centerDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate();
        }
      });
    },
    handleEdit(row, filterArr = ['updated_at', 'deleted_at', 'created_at', 'login_time']) {
      if (row.order_user_dep && row.major) {
        this.selectName = `${row.order_user_dep}-${row.major}`;
      }
      this.type = 'edit';
      this.title = '编辑';
      this.ruleForm = this.$until.delProp(row, filterArr);
      console.log(this.ruleForm);
      this.centerDialogVisible = true;
    },
    onSubmit() {
      console.log('submit!');
    },
    handleInstituteChange(e) {
      console.log(e);
      this.ruleForm.institute_name = this.$until.getLabelName(this.institutes, 'isid', 'ismc', e);
    },
    getOrganList() {
      if (this.selectNode.level == 2) {
        this.selectName = this.selectNode.structure_names;
        let strArr = this.selectNode.structure_names.split('-');
        this.ruleForm.order_user_dep = strArr[0];
        this.ruleForm.major = strArr[1];
      }
      if (!this.selectName) {
        this.ruleForm.order_user_dep = '';
        this.ruleForm.major = '';
      }

    },
    async getTarinMent() {
      let res = await this.$api.instance.getTarinMent();
      if (res.code == 0) {
        this.classRooms = res.data;
      }
    },
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.training_name = this.$until.getLabelName(this.$store.state.trainRooms, 'training_no', 'training_name', e);
    },
    handleOrganChange(val) {
      if (val) {
        // this.selectName = this.selectNode.structure_names;
        let strArr = val.split('-');
        this.ruleForm.order_user_dep = strArr[0];
        this.ruleForm.major = strArr[1];
      } else {
        this.ruleForm.order_user_dep = '';
        this.ruleForm.major = '';
      }
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.instance.interfaceServer(`api/room/order/delete/${params.id}`, 'delete', {});
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.creat.createTrainroomApply(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let res = await this.$api.instance.interfaceServer(`api/room/order/update`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.type == 'add') {
            this.createMethod();
          } else if (this.type == 'edit') {
            this.updateMethod();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleQuery() {
      this.beforeQuery()
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.query.getClassTearchList(params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
